import React from "react";
import { Button, Header, Icon, Message, Segment } from "semantic-ui-react";
import { reportClientError } from "../utils/clientLogger";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Erreur d'affichage capturée:", error, errorInfo);
    reportClientError(error, {
      source: "react_error_boundary",
      componentStack: errorInfo?.componentStack,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;

    if (!error) {
      return this.props.children;
    }

    const isChunkError =
      error?.name === "ChunkLoadError" ||
      /Loading chunk|Failed to fetch dynamically imported module/i.test(
        error?.message || "",
      );

    return (
      <Segment basic style={{ padding: 32 }}>
        <Message negative icon>
          <Icon name="warning sign" />
          <Message.Content>
            <Header as="h3">
              {isChunkError
                ? "Une nouvelle version de l'application est disponible"
                : "Une erreur empêche l'affichage de cette page"}
            </Header>
            <p>
              {isChunkError
                ? "Rechargez la page pour récupérer les derniers fichiers de l'application."
                : "Rechargez la page. Si le problème persiste, contactez l'administrateur avec l'URL consultée."}
            </p>
            <Button primary icon="refresh" content="Recharger" onClick={this.handleReload} />
          </Message.Content>
        </Message>
      </Segment>
    );
  }
}

export default AppErrorBoundary;
